<template>
  <owa-modal-frame
    title="Domains and Font Awesome Kits"
    component-class="kits-and-domains"
    :is-showing="isShowing"
    @close-modal="$emit('close-modal')"
  >
    <p class="margin-bottom-2xl">
      Just as we think it's best to have a dedicated kit per project or site, we recommend specifying particular domains for use with each of your Font Awesome
      kits.
    </p>

    <h3>Why Should I Define Domains?</h3>
    <p>
      Specifying a domain can help you control where and how you're using Font Awesome Kits - which helps avoid unexpected extreme usage as well as violation of
      the Font Awesome Pro license.
    </p>

    <h3>How do I Specify Domains?</h3>
    <p>
      You can add as many domains as you'd like. You can specify complete domains or use wildcards (*) to cover subdomains or different domain endings (.com,
      .org, etc.). Here are some examples&hellip;
    </p>

    <div style="overflow: scroll">
      <table class="roomy">
        <thead>
          <tr>
            <th>Domain Examples</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">www.empire.gov</th>
            <td>Will cover Font Awesome Kits usage for the https://www.empire.gov, but not https://empire.gov. If you need both, make sure to add each one.</td>
          </tr>
          <tr>
            <th scope="row">empire.gov</th>
            <td>Will cover Font Awesome Kits usage for the https://empire.gov, but not https://www.empire.gov. If you need both, make sure to add each one.</td>
          </tr>
          <tr>
            <th scope="row">*.rebels.org</th>
            <td>Will cover all subdomains under the rebels.org domain.</td>
          </tr>
          <tr>
            <th scope="row">council.jedi.org, padawans.jedi.org, exiled.jedi.org</th>
            <td>Will render icons on each of these specific 3 Jedi domains. Just don't tweet them out to Lord Vader.</td>
          </tr>
          <tr>
            <th
              scope="row"
              style="color: var(--fa-dk-yellow)"
            >
              the-force.*
            </th>
            <td>
              <div
                class="display-flex flex-row flex-content-between"
                style="gap: var(--spacing-2xl)"
              >
                <span style="color: var(--fa-dk-yellow)">
                  <font-awesome-icon
                    :icon="$v7.solid.faExclamationTriangle"
                    size="xl"
                  />
                </span>

                Will render icons on any domain ending so long as it contains "the-force". This may have unintended consequences since one probably does not own
                all of the domains + domain ending combinations.
              </div>
            </td>
          </tr>
          <tr>
            <th
              scope="row"
              style="color: var(--fa-dk-red)"
            >
              *.wordpress.com, *.squarespace.com
            </th>
            <td>
              <div
                class="display-flex flex-row flex-content-between"
                style="gap: var(--spacing-2xl)"
              >
                <span style="color: var(--fa-dk-red)">
                  <font-awesome-icon
                    :icon="$v7.solid.faExclamationTriangle"
                    size="xl"
                  />
                </span>

                Will make your kit, and thus Font Awesome Pro, available to any sites that are published under blogging or site creator tools like this. This is
                a violation of the Font Awesome Pro license.
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </owa-modal-frame>
</template>

<script>
  import { ModalFrameMixin } from 'app/components-wa/modals/ModalFrame'

  export default {
    name: 'ModalKitsAndDomains',

    mixins: [ModalFrameMixin]
  }
</script>
